import { isValidPhone } from './validation';
export function formatPhone(phone) {
  if (!isValidPhone(phone)) {
    return phone;
  }
  var rawPhone = phone.replace(/\D+/g, '');
  return "+".concat(rawPhone.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5'));
}
export function formatPhoneWithSpecialChars(phone) {
  if (!isValidPhone(phone)) {
    return phone;
  }
  var rawPhone = phone.replace(/\D+/g, '').replace(/^8/, '7');
  return "+".concat(rawPhone.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, "$1 ($2) $3-$4-$5"));
}
export var firstLetterToUppercase = function firstLetterToUppercase(str) {
  return str[0].toUpperCase() + str.slice(1);
};